import { render, staticRenderFns } from "./evaStatistics.vue?vue&type=template&id=01d5cef8&scoped=true&"
import script from "./evaStatistics.vue?vue&type=script&lang=js&"
export * from "./evaStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5cef8",
  null
  
)

export default component.exports